import { createRoot } from 'react-dom/client';
import { StrictMode } from 'react';
import { AllProviders } from "etl/providers";
import { App } from 'etl/app';

const root = createRoot((document.getElementById('root') as HTMLElement) || document.createElement('div'));

root.render(
  <StrictMode>
    <AllProviders>
      <App />
    </AllProviders>
  </StrictMode>
)
